import 'core-js/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import Containers from 'containers';
import './styles/core.scss';

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;
global.Components = Containers;

// Should not be necessary but was in order for client side to work
if (typeof window !== 'undefined') {
  window.React = React;
  window.ReactDOM = ReactDOM;
  window.ReactDOMServer = ReactDOMServer;
  window.Components = Containers;
}
